module.exports = __webpack_public_path__ + "static/media/Shirshasana.e41f70fe.png";